import axios from 'axios';
import { getStore, setStore } from './storage';
//import { router } from '../router/index';
import { Message } from 'view-design';
import Cookies from 'js-cookie';
import appConfig from 'appConfig';
// 统一请求路径前缀
let base = appConfig.base;
let baseMapserver = appConfig.baseMapServer;
// 超时设定
axios.defaults.timeout = appConfig.timeout ? appConfig.timeout : 15000;

axios.interceptors.request.use(
  config => {
    return config;
  },
  err => {
    Message.warning('请求超时');
    return Promise.resolve(err);
  }
);

// http response 拦截器
// axios.interceptors.response.use(
//   response => {
//     const data = response.data;
//     // 根据返回的code值来做不同的处理(和后端约定)
//     switch (data.code) {
//       case 401:
//         // 未登录 清除已登录状态
//         Cookies.set('userInfo', '');
//         setStore('accessToken', '');
//         router.push('/login');
//         break;
//       case 403:
//         // 没有权限
//         if (data.message !== null) {
//           Message.warning(data.message);
//         } else {
//           Message.warning('未知错误');
//         }
//         break;
//       case 500:
//         // 错误
//         if (data.message !== null) {
//           Message.warning(data.message);
//         } else {
//           Message.warning('未知错误');
//         }
//         break;
//       default:
//         return data;
//     }

//     return data;
//   },
//   err => {
//     // 返回状态码不为200时候的错误处理
//     Message.warning(err.toString());
//     return Promise.resolve(err);
//   }
// );

export const postloginRequest = (url, params) => {
  let accessToken = Cookies.get('accessToken');
  return axios({
    method: 'post',
    url: `${base}${url}`,
    data: params,
    transformRequest: [
      function(data) {
        let ret = '';
        for (let it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
        }
        return ret;
      },
    ],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      accessToken: accessToken,
    },
  });
};

// // 订单
// export const getOrderLisRequest = (url, params) => {
//   //let accessToken = getStore("accessToken");
//   let accessToken = Cookies.get("accessToken")
//   return axios({
//     method: 'get',
//     url: `${base}${url}`,
//     params: params,
//     headers: {
//       'Content-Type': 'application/json',
//       'accessToken': accessToken
//     }
//   });
// };

export const getRequest = (url, params) => {
  let accessToken = Cookies.get('accessToken');
  return axios({
    method: 'get',
    url: `${base}${url}`,
    params: params,
    headers: {
      // 'Content-Type': 'application/json',
      accessToken: accessToken,
    },
  });
};

// 商品详情
export const getDetails1 = (url, params) => {
  return axios({
    method: 'post',
    url: `${base}${url}`,
    params: params,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getRequest3 = (url, params) => {
  let accessToken = getStore('accessToken');
  return axios({
    method: 'post',
    url: `${base}${url}`,
    data: params,
    headers: {
      'Content-Type': 'application/json',
      accessToken: accessToken,
    },
  });
};

export const getRequest4 = (url, params) => {
  let accessToken = Cookies.get('accessToken');
  return axios({
    method: 'post',
    url: `${url}`,
    data: params,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      accessToken: accessToken,
    },
  });
};

export const getRequest2 = url => {
  let accessToken = getStore('accessToken');

  var url = `${base}${url}`;
  //var $a = $("<a></a>").attr("href",url).attr("target","_Blank"); // 新窗口打开
  var $a = $('<a></a>')
    .attr('href', url)
    .attr('download', '属性模板.xlsx'); //下载
  $a[0].click();
};
export const postDataRequestexCode = (url, params) => {
  let accessToken = Cookies.get('accessToken');
  return axios({
    method: 'post',
    url: `${base}${url}`,
    data: params,
    headers: {
      'Content-Type': 'application/json',
      accessToken: accessToken,
    },
  });
};

export const postGeoserverplugin = (url, params) => {
  let accessToken = Cookies.get('accessToken');
  return axios({
    method: 'post',
    url: `${'/zituSpace' + url}`,
    data: params,
    headers: {
      'Content-Type': 'application/json',
      accessToken: accessToken,
    },
  });
};



// WEBPACK FOOTER //
// ./src/utils/axiosPlus.js